import { ViewportType } from '../../../enums';
export const ECG_PROJECTION_ID = 'ecg';
